import { Color } from './color';
/**
 * ⭓
 */
export const Hexagon = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'hexagon' }, options), context);
};
Hexagon.props = Object.assign({ defaultMarker: 'hexagon' }, Color.props);
//# sourceMappingURL=hexagon.js.map